import PropTypes from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 5 minutes before </strong>
      your appointment time
    </li>
    <li>
      Please bring any existing eyewear including glasses and/or contact lenses with you to your
      appointment, and if you&apos;ve confirmed that you&apos;re eligible for a free NHS-funded eye
      test, please bring any related documentation
    </li>
    <li>
      Customers aged 16 or under must be accompanied to their appointment by a parent or guardian
    </li>
    <li>
      Find out more about NHS eye test eligibility{' '}
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-services/opticians`}
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
